
















import Vue from "vue";
import Component from "vue-class-component";
import ChartAnchorageLayer from "../features/ChartAnchorageLayer.vue";
import FixedPlatformsLayer from "../features/FixedPlatformsLayer.vue";
import PipelineLayer from "../features/PipelineLayer.vue";
import MobilePlatformsLayer from "../features/MobilePlatformsLayer.vue";
import LinearPlatformsLayer from "../features/LinearPlatformsLayer.vue";
import NavChannelsLayer from "../features/NavChannelsLayer.vue";
import { LLayerGroup } from "vue2-leaflet";
import { maps } from "@/store";

@Component({
  components: {
    LLayerGroup,
    FixedPlatformsLayer,
    ChartAnchorageLayer,
    PipelineLayer,
    MobilePlatformsLayer,
    LinearPlatformsLayer,
    NavChannelsLayer,
  },
})
export default class MapFeatures extends Vue {
  get selectedFeatures() {
    return maps.getters.selectedFeatures;
  }
}
